import React from 'react';


const PrintComponent = (props) => {

	return <div  dangerouslySetInnerHTML={{__html: props.reportPDF}}
	            ref={props.componentRef}></div>
}
export default PrintComponent;